import React from "react";
import { trustedBy } from "../mock";

// TimesFuture official wordmark (per supplied brand spec)
function TimesFutureMark({ scale = 1 }) {
  const t = (n) => `${n * scale}px`;
  return (
    <div className="flex flex-col items-center justify-center">
      <span
        style={{
          fontFamily: '"Bodoni Moda", Didot, "Times New Roman", serif',
          fontWeight: 900,
          fontSize: t(34),
          lineHeight: 0.86,
          letterSpacing: "-0.015em",
          color: "#0D0D10",
        }}
      >
        TIMES
      </span>
      <span
        style={{
          width: t(82),
          height: t(1.5),
          background: "#B8956B",
          margin: `${t(4)} 0`,
          display: "block",
        }}
      />
      <span
        style={{
          fontFamily: '"Barlow Condensed", "Oswald", Inter, sans-serif',
          fontWeight: 500,
          textTransform: "uppercase",
          fontSize: t(12),
          letterSpacing: "0.32em",
          paddingLeft: "0.32em",
          color: "#B8956B",
          lineHeight: 1,
        }}
      >
        FUTURE
      </span>
    </div>
  );
}

function SerendipityMark() {
  return (
    <span
      style={{
        fontFamily: '"Playfair Display", Georgia, serif',
        fontStyle: "italic",
        fontWeight: 500,
        fontSize: "22px",
        letterSpacing: "0.01em",
        color: "#1e1b4b",
        lineHeight: 1,
      }}
    >
      Serendipity{" "}
      <span style={{ fontWeight: 700, color: "#d4af37" }}>Catering</span>
    </span>
  );
}

function GardenHeroMark() {
  return (
    <span
      className="flex items-baseline gap-1.5"
      style={{
        fontFamily: "Inter, sans-serif",
        fontWeight: 800,
        fontSize: "20px",
        letterSpacing: "-0.025em",
        color: "#1e1b4b",
        lineHeight: 1,
      }}
    >
      <span style={{ color: "#16a34a" }}>Garden</span>
      <span>Hero</span>
    </span>
  );
}

function LogoTile({ partner }) {
  const isDark = partner.tone === "dark";
  const isCream = partner.tone === "cream";

  let bg = "bg-white";
  if (isDark) bg = "bg-[#0d0d10]";
  if (isCream) bg = "bg-[#f4f1e8]";

  // Per-logo fine-tuning to compensate for source-PNG padding
  const imgClass =
    partner.name === "World Food Bank"
      ? "max-h-16 max-w-[85%] object-contain"
      : partner.name === "eSkrybe"
      ? "max-h-[170%] max-w-[170%] object-contain object-center -my-6"
      : partner.name === "Trade Oracle Group"
      ? "max-h-[150%] max-w-[140%] object-contain object-center -my-4"
      : "max-h-14 max-w-full object-contain";

  return (
    <div
      title={partner.name}
      className={`group flex h-24 w-full items-center justify-center overflow-hidden rounded-xl border border-slate-200 ${bg} px-5 transition-all hover:-translate-y-0.5 hover:border-slate-300 hover:shadow-md`}
    >
      {partner.kind === "image" && (
        <img
          src={partner.src}
          alt={partner.name}
          loading="lazy"
          className={imgClass}
        />
      )}
      {partner.kind === "timesfuture" && <TimesFutureMark scale={1.15} />}
      {partner.kind === "wordmark-serif" && <SerendipityMark />}
      {partner.kind === "wordmark-sans" && <GardenHeroMark />}
    </div>
  );
}

export default function TrustedBy() {
  return (
    <section className="border-y border-slate-200 bg-white py-12">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <p className="text-center text-[10.5px] font-semibold uppercase tracking-[0.2em] text-slate-500">
          Trusted by teams who refuse to guess
        </p>
        <div className="mt-7 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
          {trustedBy.map((p) => (
            <LogoTile key={p.name} partner={p} />
          ))}
        </div>
      </div>
    </section>
  );
}
